import { SVGProps, Ref, forwardRef } from 'react';

export const BackwardFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.51 7.143c2.03-.977 3.046-1.465 3.768-.91C12 6.79 12 8.06 12 10.597v2.806c0 2.538 0 3.808-.722 4.364-.722.555-1.738.067-3.768-.91l-2.92-1.403C1.53 13.983 0 13.247 0 12s1.53-1.983 4.59-3.454z"
                fill="currentColor"
            />
            <path
                d="M19.51 7.143c2.03-.977 3.046-1.465 3.768-.91C24 6.79 24 8.06 24 10.597v2.806c0 2.538 0 3.808-.722 4.364-.722.555-1.737.067-3.768-.91l-2.92-1.403C13.53 13.983 12 13.247 12 12s1.53-1.983 4.59-3.454z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BackwardFilledSize24Glyph.displayName = 'BackwardFilledSize24Glyph';
